import { IconProps } from '../Icons.type'

export function CockIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      fill="none"
      viewBox="0 0 21 21"
      {...props}>
      <g
        fill="currentColor"
        fillRule="evenodd"
        clipPath="url(#clip0_4052_94867)"
        clipRule="evenodd">
        <path d="M10.898 2.973a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm-9.167 7.5a9.167 9.167 0 1118.334 0 9.167 9.167 0 01-18.334 0z"></path>
        <path d="M10.898 4.639c.46 0 .834.373.834.833v5a.833.833 0 01-.461.745l-3.333 1.667a.833.833 0 11-.746-1.49l2.873-1.437V5.472c0-.46.373-.833.833-.833z"></path>
      </g>
      <defs>
        <clipPath id="clip0_4052_94867">
          <path
            fill="currentColor"
            d="M0 0H20V20H0z"
            transform="translate(.898 .473)"></path>
        </clipPath>
      </defs>
    </svg>
  )
}
